import { Button, Heading, Text } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";
import { Flex } from "styled-system/jsx";

type PersonContactInfoModalHeaderProps = {
  onBackClick: () => void;
  variant?: "default" | "editProfile";
};

export const PersonContactInfoModalHeader = ({
  onBackClick,
  variant = "default",
}: PersonContactInfoModalHeaderProps) => {
  const { t } = useTranslation("people", {
    keyPrefix: "PERSON_CONTACT_INFO_MODAL",
  });

  return (
    <Flex flexDir="column" gap="300">
      <Button
        visual="primary"
        mode="light"
        w="fit-content"
        size="sm"
        type="button"
        onClick={onBackClick}
      >
        {t("BACK")}
      </Button>
      <Flex flexDir="column" gap="200">
        <Heading size="h4">
          {variant === "editProfile" ? t("TITLE_EDIT_PROFILE") : t("TITLE")}
        </Heading>
        <Text color="text.mid">
          {variant === "editProfile"
            ? t("DESCRIPTION_EDIT_PROFILE")
            : t("DESCRIPTION")}
        </Text>
      </Flex>
    </Flex>
  );
};
